import { render, staticRenderFns } from "./add-trial.vue?vue&type=template&id=3e2b8aea"
import script from "./add-trial.vue?vue&type=script&lang=js"
export * from "./add-trial.vue?vue&type=script&lang=js"
import style0 from "./add-trial.vue?vue&type=style&index=0&id=3e2b8aea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports